module.exports = __webpack_public_path__ + "media/4x3/bs-9f8a4eae.svg";